import Vue from "vue"
import VueRouter from "vue-router"
import VueAnalytics from "vue-analytics"
import app from "@/app"
import router from "@/router"
import { state, actions } from "@/store"
import { I18n, messages } from "@/i18n"
import { focusDirective, clickOutsideDirective } from "@/directives"
import { formatNumberFilter } from "@/filters"
import { logger } from "@/logger"
import "./registerServiceWorker"

const i18n = new I18n({
  messages,
  defaultLocale: "en",
  locale: () => state.lang
})

Vue.use(i18n)
Vue.use(VueRouter)
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA,
  router,
  debug: {
    sendHitTask: !!process.env.VUE_APP_GA
  }
})
Vue.use(logger)

Vue.directive("focus", focusDirective)
Vue.directive("click-outside", clickOutsideDirective)

Vue.filter("money", formatNumberFilter(2))

Vue.config.errorHandler = err => {
  Vue.$logger.error("Uncaught vue ex", err)
}

const vue = new Vue({
  created() {
    window.addEventListener("beforeunload", function(event) {
      if (state.pendingActionsSize > 0) {
        event.preventDefault()
        event.returnValue = ""
      }
    })
  },
  router,
  render: h => h(app)
}).$mount("#app")

if (process.env.NODE_ENV === "development") {
  Vue.config.productionTip = false
  window.state = state
  window.actions = actions
  window.vue = vue
}
